import { TW_address } from '@/constants/Address';
import { cloneDeep } from 'lodash';

const initAreaData = (stateValue) => {
  const areas = cloneDeep(
    TW_address.filter((data) => data.name === stateValue)[0].districts
  );
  const tempAreaData = areas.map((data) => {
    return data;
  });
  return tempAreaData;
};

const getZipCode = (stateValue, cityValue) => {
  const cities = initAreaData(stateValue);
  const zipCode = cities.filter((city) => city.name === cityValue)[0].zip;
  return zipCode;
};

const createStructAddress = (
  stateValue: string,
  cityValue: string,
  address: string
) => {
  const zipCode = String(getZipCode(stateValue, cityValue));

  const structAddress = {
    street_address: [address],
    state: stateValue,
    city: cityValue,
    zip_code: zipCode,
  };
  return JSON.stringify(structAddress);
};

const deconstructAddress = (address: string) => {
  return JSON.parse(address);
};

const uberDirectStructAddress = { createStructAddress, deconstructAddress };
export default uberDirectStructAddress;
